import { DeviceSelectionContainer } from 'components';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../MenuItem';

type SettingsMenuProps = {
  className?: string;
  withLayoutSelection?: boolean;
  withBackground?: boolean;
  forceLightTheme?: boolean;
};

export function SettingsMenu({ className, withBackground, withLayoutSelection, forceLightTheme }: SettingsMenuProps) {
  const { t } = useTranslation('providerRoom');

  return (
    <>
      <MenuItem title={t('menus.settings')} className={className}>
        <DeviceSelectionContainer
          withMasterVolume
          withBackground={withBackground}
          withLayoutSelection={withLayoutSelection}
          withThemeSelection
          withLanguageSelection
          viewAtBottom
          withAudioDiagnostic
          inlineAudioDiagnostic
          microphoneFirst
          forceLightTheme={forceLightTheme}
        />
      </MenuItem>
    </>
  );
}
